var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import entitiesUtil from "../../Entities/utils/filterBaseProperties";
import { Select as SimpleSelect } from "../../Forms";
import { I18NLink, t, Translate } from "../../I18N";
import { notificationActions } from "../../Notifications";
import { FormGroup } from "../../ReactReduxForms";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { Icon } from "../../UI";
import { wrapEntityMetadata } from "./..";
import defaultTemplate from "../helpers/defaultTemplate";
import validator from "../helpers/validator";
import { IconField } from "./IconField";
import MetadataFormFields from "./MetadataFormFields";
import { MetadataExtractor } from "./MetadataExtractor";
import { SupportingFiles } from "./SupportingFiles";
import { PDFUpload } from "./PDFUpload";
import { DeleteSelectionButton } from "./DeleteSelectionButton";

const immutableDefaultTemplate = Immutable.fromJS(defaultTemplate);
const selectTemplateOptions = createSelector(
  (s) => s.templates,
  (templates) => templates.map((tmpl) => ({ label: tmpl.get('name'), value: tmpl.get('_id') }))
);

class MetadataForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitFailed = this.onSubmitFailed.bind(this);
  }

  componentWillUnmount() {
    this.props.componentWillUnmount();
  }

  onSubmit(entity) {
    this.props.onSubmit(
      wrapEntityMetadata(entitiesUtil.filterBaseProperties(entity), this.props.template.toJS()),
      this.props.model
    );
  }

  onSubmitFailed() {
    this.props.notify(t('System', 'Invalid form', null, false), 'danger');
  }

  renderTemplateSelect(templateOptions, template) {
    if (templateOptions.size) {
      const sortedTemplates = templateOptions.toJS().sort((a, b) => a.label > b.label ? 1 : -1);

      return (/*#__PURE__*/
        _jsx(FormGroup, {}, void 0, /*#__PURE__*/
        _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
        _jsx("li", {}, void 0, /*#__PURE__*/
        _jsx("label", {}, void 0, t('System', 'Type'))
        ), /*#__PURE__*/
        _jsx("li", { className: "wide" }, void 0,
        this.props.initialTemplateId !== undefined &&
        this.props.initialTemplateId !== this.props.templateId && /*#__PURE__*/
        _jsx("span", {}, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "exclamation-triangle" }), /*#__PURE__*/
        _jsx(Translate, { context: "System" }, void 0, "Changing the type will erase all relationships to this entity."

        )
        )

        ), /*#__PURE__*/
        _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
        _jsx(SimpleSelect, {
          className: "form-control",
          value: template.get('_id'),
          options: sortedTemplates,
          onChange: (e) => {
            this.props.changeTemplate(this.props.model, e.target.value);
          } }
        )
        )
        )
        ));

    }

    return (/*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "text-center protip" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "lightbulb" }), ' ', /*#__PURE__*/
      _jsx("b", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "ProTip!")
      ), /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "You can create metadata templates in"), ' ', /*#__PURE__*/
      _jsx(I18NLink, { to: "/settings" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "settings")
      ), "."

      )
      )
      ));

  }

  render() {
    const {
      model,
      template,
      templateOptions,
      id,
      multipleEdition,
      showSubset,
      version,
      storeKey,
      highlightedProps,
      attachments,
      sharedId,
      progress
    } = this.props;

    if (!template) {
      return /*#__PURE__*/_jsx("div", {});
    }
    const titleLabel = template.get('commonProperties') ?
    template.
    get('commonProperties').
    find((p) => p.get('name') === 'title').
    get('label') :
    'Title';

    return (/*#__PURE__*/
      _jsx("fieldset", { disabled: progress !== undefined }, void 0, /*#__PURE__*/
      _jsx(Form, {
        id: id,
        model: model,
        onSubmit: this.onSubmit,
        validators: validator.generate(template.toJS(), multipleEdition),
        onSubmitFailed: this.onSubmitFailed }, void 0,

      !multipleEdition && (!showSubset || showSubset.includes('title')) && /*#__PURE__*/
      _jsx(FormGroup, { model: ".title" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { context: template.get('_id') }, void 0, titleLabel), ' ', /*#__PURE__*/
      _jsx("span", { className: "required" }, void 0, "*")
      )
      ), /*#__PURE__*/
      _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "metadata-extractor-container" }, void 0,
      storeKey === 'documentViewer' && /*#__PURE__*/
      _jsx(MetadataExtractor, { fieldName: "title", model: `${model}.title` }), /*#__PURE__*/

      _jsx(Field, { model: ".title" }, void 0, /*#__PURE__*/
      _jsx("textarea", { className: "form-control" })
      )
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-title-actions" }, void 0,
      storeKey === 'documentViewer' && /*#__PURE__*/_jsx(DeleteSelectionButton, { propertyName: "title" }), /*#__PURE__*/
      _jsx(IconField, { model: model })
      )
      )
      ),


      (!showSubset || showSubset.includes('template')) &&
      this.renderTemplateSelect(templateOptions, template), /*#__PURE__*/
      _jsx(MetadataFormFields, {
        multipleEdition: multipleEdition,
        thesauris: this.props.thesauris,
        model: model,
        template: template,
        showSubset: showSubset,
        version: version,
        highlightedProps: highlightedProps,
        storeKey: storeKey }
      ),
      !multipleEdition && !showSubset && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(PDFUpload, { entitySharedID: sharedId, model: model }), /*#__PURE__*/
      _jsx(SupportingFiles, {
        supportingFiles: attachments,
        entitySharedID: sharedId,
        model: model }
      )
      )

      )
      ));

  }
}

MetadataForm.defaultProps = {
  id: 'metadataForm',
  multipleEdition: false,
  showSubset: undefined,
  version: undefined,
  initialTemplateId: undefined,
  componentWillUnmount: () => {},
  notify: () => {},
  changeTemplate: () => {},
  onSubmit: () => {},
  highlightedProps: [],
  storeKey: '',
  attachments: [],
  sharedId: '',
  progress: undefined
};






















function mapDispatchToProps(dispatch) {
  return bindActionCreators({ notify: notificationActions.notify }, dispatch);
}
export const mapStateToProps = (state, ownProps) => {
  const entityModel = ownProps.model.split('.').reduce((o, i) => o[i], state);
  const { attachments, sharedId } = entityModel;
  let progress = state.attachments.progress.get('NEW_ENTITY');
  if (sharedId) {
    const storeProgress = state.attachments.progress.get(sharedId);
    progress = storeProgress < 100 ? storeProgress : undefined;
  }
  return {
    thesauris: ownProps.thesauris ? ownProps.thesauris : state.thesauris || Immutable.fromJS([]),
    template: ownProps.template ?
    ownProps.template :
    state.templates.find((tmpl) => tmpl.get('_id') === ownProps.templateId) ||
    immutableDefaultTemplate,
    templateOptions: selectTemplateOptions(state),
    attachments,
    sharedId,
    progress
  };
};

export { MetadataForm };
export default connect(mapStateToProps, mapDispatchToProps)(MetadataForm);